var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"iconfont iconshuxian"}),_c('span',{staticClass:"main-title"},[_vm._t("mainTitle")],2),_c('span',{staticClass:"second-title"},[_vm._t("secondTitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }